// Import Angular browser bootstrapper.
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// Import root application module.
import { AppModule } from './app/app.module';

// Bootstrap root module and log startup errors.
platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
